define('GameDayCore/GDModel/ValueObjects/Boxscore/BoxPlayer',['require','exports','module','../ValueObjectFactory'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory');

	VO.create(BoxPlayer);

	function BoxPlayer($data) {
		var vo = VO.ensureVO(this, BoxPlayer),
			data = $data;

        vo.id = data.id || "";
        vo.name = data.name || "";
        vo.name_display_first_last = data.name_display_first_last || "";
        vo.pos = data.pos || "";
        vo.b_or_p = (data.pos === "P") ? "p" : "b";
        vo.bo = data.bo;
        vo.displayBo = (data.bo && data.bo.substring(1) == "00") ? data.bo.substring(0,1) : "";
        vo.ab = data.ab || "";
        vo.po = data.po || "";
        vo.r = data.r || "";
        vo.a = data.a || "";
        vo.bb = data.bb || "";
        vo.sac = data.sac || "";
        vo.t = data.t || "";
        vo.sf = data.sf || "";
        vo.h = data.h || "";
        vo.e = data.e || "";
        vo.d = data.d || "";
        vo.hbp = data.hbp || "";
        vo.so = data.so || "";
        vo.hr = data.hr || "";
        vo.rbi = data.rbi || "";
        vo.lob = data.lob || "";
        vo.fldg = data.fldg || "";
        vo.sb = data.sb || "";
        vo.cs = data.cs || "";
        vo.s_hr = data.s_hr || "";
        vo.s_rbi = data.s_rbi || "";
        vo.s_h = data.s_h || "";
        vo.s_bb = data.s_bb || "";
        vo.s_r = data.s_r || "";
        vo.s_so = data.s_so || "";
        vo.avg = data.avg || "";
        vo.ops = data.ops || "";
        vo.go = data.go || "";
        vo.ao = data.ao;
        vo.out = data.out || "";
        vo.bf = data.bf || "";
        vo.er = data.er || "";
        vo.np = data.np|| "";
        vo.s = data.s || "";
        vo.w = data.w || "";
        vo.l = data.l || "";
        vo.sv = data.sv || "";
        vo.bs = data.bs || "";
        vo.hld = data.hld || "";
        vo.s_ip = data.s_ip || "";
        vo.s_er = data.s_er || "";
        vo.era = data.era;
        vo.note = data.note;
        vo.isSubstitute  = data.bo && data.bo.substring(1) !== "00";
	}

	return BoxPlayer;
});
